export enum TransactionTypeEnum {
  TopUp = 1,
  Pay = 2,
  Refund = 3,
  Withdraw = 4
}
